import React, { useState } from 'react';
import {
	Flex,
	Heading,
	Text,
	UnorderedList,
	ListItem,
	useMediaQuery,
	Stack,
	VStack,
	Box,
} from '@chakra-ui/react';

// import { Carousels } from 'Constants/ImageSliderConstant';
// import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import { HowItWorksDesktop } from './HowItWorksDesktop';
import { HowItWorksMobile } from './HowItWorksMobile';
import { ILoopLandingPageLocalizationDocument } from 'Types/Interface/Sanity';

import { IImageSlider } from 'Types/Interface/ILandingPage';

interface IHowItWorkSectionProps{
	loopLandingPageLocalization?: ILoopLandingPageLocalizationDocument | null;
	mainHeading?: string;
	secondaryHeading?: string;
	SliderContent: IImageSlider[];
	isLoopBusiness: boolean;
}

export const HowItWorksSection = ({mainHeading, secondaryHeading, isLoopBusiness, SliderContent }: IHowItWorkSectionProps) => {
	const [currentSlide, setcurrentSlide] = useState(0);
	const [isLargerThan768] = useMediaQuery('(min-width: 768px)');
	const active = currentSlide;

	// const onRight = () => {
	// 	if (currentSlide < SliderContent.length - 1) {
	// 		setcurrentSlide(currentSlide + 1);
	// 	}
	// };

	// const onLeft = () => {
	// 	if (currentSlide > 0) {
	// 		setcurrentSlide(currentSlide - 1);
	// 	}
	// };

	const Slidernavigation = (index: number) => {
		setcurrentSlide(index);
	};

	const activeCarousel = {
		desktop: <HowItWorksDesktop Carousels={SliderContent} currentSlide={currentSlide} />,
		mobile: <HowItWorksMobile isLoopBusiness={isLoopBusiness} Carousels={SliderContent} />
	};

	return (
		<>
			<Flex
				direction={'column'}
				maxW={'100%'}
				pt={['40px', '100px']}
			>
				<VStack spacing={['50px', '40px']} w={['100%', null, null, '100%']} align={'flex-start'}>
					<Stack spacing={['20px', '30px']}>
						<Heading
							fontSize={{ base: '30px', tablet: '2xl', xxl: '40px' }}
							fontWeight={'bold'}
							textTransform={'uppercase'}
						>
							{mainHeading}
						</Heading>
						<Text fontSize={['16px', '18px']} fontWeight={500} color={'#2B2B2B;'}>
							{secondaryHeading}
						</Text>
					</Stack>
					<Flex justifyContent={'space-between'} w={'100%'}>
						<Flex direction={'column'} mt="8" >
							{/* <Flex
								cursor={'pointer'}
								ml={3}
								h={10}
								display={['none', 'none', 'block']}
							>
								<ArrowBackIcon
									onClick={onLeft}
									boxSize={5}
									w={10}
									color={currentSlide > 0 ? '#586068' : '#E1E7EA'} />
								<ArrowForwardIcon
									onClick={onRight}
									boxSize={5}
									w={10}
									color={currentSlide < SliderContent.length - 1 ? '#586068' : '#E1E7EA'} />
							</Flex> */}
							{SliderContent?.map((Carousel, index) => {
								return (
									<UnorderedList key={Carousel.id}>
										<ListItem
											mb={6}
											listStyleType={'none'}
											fontSize={'md'}
											fontWeight={active === index ? 'semibold' : 'normal'}
											color={active === index ? '#121B26' : '#96999B'}
											_hover={{ color: '#121B26', fontWeight: '600' }}
											cursor={'pointer'}
											onClick={() => Slidernavigation(index)}
											display={['none', 'none', 'block']}
											borderLeft={active === index ? '2px solid #FF6F61' : 'none'}
											pl={active === index ? 2 : 0}
										>
											{Carousel.label}
										</ListItem>
									</UnorderedList>
								);
							})}
						</Flex>
						<Flex
							justifyContent={'space-between'}
							alignItems={'center'}
							w={['100%', '75%']}
							overflow={['', '', 'hidden']}
						>
							{activeCarousel[isLargerThan768 ? 'desktop' : 'mobile']}
						</Flex>
					</Flex>
				</VStack>
			</Flex>
			<Flex display={['none', 'flex']} gap={3} justifyContent={'center'} alignItems={'center'} mt={['20px', '30px']}>
				{
					SliderContent?.map((Carousel, index) => {
						return (
							<Box
								key={Carousel.id}
								cursor={'pointer'}
								h={'8px'}
								w={'8px'}
								borderRadius={'50%'}
								bgColor={active === index ? '#FF6F61' : '#D0D4D9'}
								onClick={() => Slidernavigation(index)}
							/>
						);
					})
				}
			</Flex>
			
		</>
	);
};